export const downloadFile = (response, nameFile) => {
	const blob = new Blob([response.data], { type: 'application/zip' })
	const link = document.createElement('a')
	link.href = window.URL.createObjectURL(blob)
	link.setAttribute('download', nameFile)
	link.click()
}

export const downloadFileCsv = (response, nameFile) => {
	const blob = new Blob([response.data], { type: 'application/json' })
	const link = document.createElement('a')
	link.href = window.URL.createObjectURL(blob)
	link.setAttribute('download', nameFile)
	link.click()
}


// function download(pdfUrl) {
// 	fetch(pdfUrl).then(resp => resp.arrayBuffer()).then(resp => {
//
// 		// set the blog type to final pdf
// 		const file = new Blob([resp], {type: 'application/pdf'});
//
// 		// process to auto download it
// 		const fileURL = URL.createObjectURL(file);
// 		const link = document.createElement('a');
// 		link.href = fileURL;
// 		link.download = "FileName" + new Date() + ".pdf";
// 		link.click();
// 	});
// }
export const downloadFilePDF = (response, nameFile) => {
	const blob = new Blob([response.data], { type: 'application/pdf' })
	const link = document.createElement('a')
	link.href = window.URL.createObjectURL(blob)
	link.setAttribute('download', nameFile)
	link.click()
}
